import React, { FC } from 'react';
import classNames from 'classnames';
import { IconProps } from './type';

export const Count: FC<React.PropsWithChildren<IconProps & { count?: number }>> = ({ className, width = 20, height = 20, count }) => (
  <svg className={classNames([className])} width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    {count === 1 ? (
      <path
        d="M11.4845 14.1525H9.4923V8.51281H7.50011V7.01281L8.22081 6.95226C9.36047 6.86818 9.84009 6.47197 9.96007 5.50011H11.4845V14.1525Z"
        fill="#005AD9"
      />
    ) : null}
    {count === 2 ? (
      <path
        // eslint-disable-next-line max-len
        d="M7.04826 14.0003V12.4043L9.86826 9.83633C11.0803 8.74433 11.2723 8.45633 11.2723 7.89233C11.2723 7.38833 10.8523 6.95633 10.1323 6.95633C9.35226 6.95633 8.88426 7.48433 8.90826 8.38433L7.00026 8.10833C7.02426 6.42833 8.34426 5.25233 10.1443 5.25233C12.0643 5.25233 13.2763 6.30833 13.2763 7.79633C13.2763 8.81633 12.9163 9.42833 11.4043 10.7483L9.58026 12.2843H13.3123V14.0003H7.04826Z"
        fill="#005AD9"
      />
    ) : null}
    {count === 3 ? (
      <path
        // eslint-disable-next-line max-len
        d="M10.1702 14.3804C8.37024 14.3804 6.99024 13.4564 6.75024 11.7044L8.70624 11.3924C8.80224 12.2444 9.39024 12.7244 10.1342 12.7244C10.8542 12.7244 11.4062 12.3524 11.4062 11.6324C11.4062 10.9244 10.8302 10.6484 10.0142 10.6484H9.21024V9.05237H9.99024C10.7462 9.05237 11.2382 8.76437 11.2382 8.11637C11.2382 7.52837 10.8302 7.15637 10.1462 7.15637C9.40224 7.15637 8.92224 7.69637 8.80224 8.42837L6.96624 8.21237C7.17024 6.71237 8.34624 5.50037 10.2302 5.50037C12.0542 5.50037 13.1702 6.55637 13.1702 7.98437C13.1702 8.86037 12.6542 9.55637 12.0062 9.80837C12.7742 10.1084 13.3622 10.7324 13.3622 11.8004C13.3622 13.2164 12.1262 14.3804 10.1702 14.3804Z"
        fill="#005AD9"
      />
    ) : null}

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M2.92882 2.92882C6.83399 -0.976347 13.1661 -0.9762 17.0714 2.92882C20.9766 6.83406 20.9766 13.1662 17.0714 17.0714C13.1662 20.9766 6.83406 20.9766 2.92882 17.0714C-0.976201 13.1661 -0.976347 6.83399 2.92882 2.92882ZM15.6573 4.34288C12.5331 1.21891 7.467 1.21876 4.34288 4.34288C1.21876 7.467 1.21891 12.5331 4.34288 15.6573C7.46708 18.7815 12.5331 18.7815 15.6573 15.6573C18.7815 12.5331 18.7815 7.46708 15.6573 4.34288Z"
      fill="#005AD9"
    />
  </svg>
);
